import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsolidatedPendingsOrdersService {

  constructor(private _httpClient: HttpClient) {}

  exportGeneralConsolidated(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedPendingsOrders.ExportGeneralConsolidated}`, filters, {
      params, responseType: 'blob',
    });
  }

  getColumnsForGeneralConsultationConsolidatedAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedPendingsOrders.GetColumnsForGeneralConsultationConsolidatedAsync}`);
  }

  getAllConsolidatedPendingsOrdersAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.consolidatedPendingsOrders.GetAllConsolidatedPendingsOrdersAsync}`,
      filters, { params: params }
    );
  }
  
}
